import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel, getUserProps } from '..';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

export interface CtaDriverTrackingProps {
  interactionCTA: string;
  elementListPosition?: number | '';
  elementTargetCategoryPrimary: string;
  elementTargetPageType: string;
  pageTypeCTA?: string;
  elementTitle?: string;
  titleCTA?: string;
  elementListName?: string;
  elementType?: string;
  typeCTA?: string;
  modules?: FaaLandingPageModule[];
}

const trackCtaDriver = ({
  interactionCTA,
  elementListPosition = '',
  elementTargetCategoryPrimary,
  elementTargetPageType,
  pageTypeCTA = elementTargetPageType,
  elementTitle = '',
  titleCTA = elementTitle,
  elementListName = 'Find an Agent CTA Drivers',
  elementType = 'Widget',
  typeCTA = elementType,
  modules = getVisibleLandingPageModules(),
}: CtaDriverTrackingProps): void => {
  sendToMixpanel('Tap CTA Driver', {
    categoryCTA: elementTargetCategoryPrimary,
    pageTypeCTA,
    titleCTA,
    typeCTA,
    interactionCTA,
    modules,
    modulesCount: modules.length,
    ...getUserProps(),
  });

  pushToDataLayer({
    event: 'cta_driver',
    event_parameters: {
      element_list_name: elementListName,
      element_list_position: elementListPosition,
      element_target_category_primary: elementTargetCategoryPrimary,
      element_target_page_type: elementTargetPageType,
      element_text: interactionCTA,
      element_title: elementTitle,
      element_type: elementType,
    },
  });
};

export default trackCtaDriver;
